import { SWR_KEYS } from 'constants/constants';
import { getCountriesOpenForSelling } from 'services/countriesList';
import useSWR from 'swr';

export function useCatalogExchange() {
  const {
    data: countries,
    error: countriesError,
    isLoading: areCountriesLoading
  } = useSWR(SWR_KEYS.catalogExchanges, getCountriesOpenForSelling);

  return { 
    countries: countries ?? [],
    countriesError, 
    areCountriesLoading 
  };
}
